var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Dropdown',{attrs:{"options":_vm.options,"width":250},on:{"select":_vm.handleOption},scopedSlots:_vm._u([{key:"button-content",fn:function(){return [_c('Button',{attrs:{"icon":"+","rounded":""}})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }